/**
 * Checks if teads can be injected. Returns true if no other teads have been
 * injected and the current word count is >= required configuration.
 * @param {Number} currentWordCount Current word count since last teads injection.
 * @param {Number} teadsCount Total number of teads injected.
 * @param {Number} minNumOfWordsBeforeTeads Number of word before teads can be injected.
 * @returns {Boolean}
 */
const isRightNumberOfWordsForTeads = ({
  currentWordCount,
  teadsCount,
  props: {
    adSettings: {
      minNumOfWordsBeforeTeads,
    },
  },
}) => {
  if (!minNumOfWordsBeforeTeads && minNumOfWordsBeforeTeads !== 0) return false;

  return (
    teadsCount === 0 && currentWordCount >= minNumOfWordsBeforeTeads
  );
};

export default isRightNumberOfWordsForTeads;
